var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "collection-sorting" },
    [
      _vm.$mq !== "mobile"
        ? _c("select-input", {
            attrs: { disableDefault: true, options: _vm.sortingOptions },
            model: {
              value: _vm.currentValue,
              callback: function($$v) {
                _vm.currentValue = $$v
              },
              expression: "currentValue"
            }
          })
        : _c(
            "div",
            { staticClass: "collection-sorting__mobile" },
            _vm._l(_vm.sortingOptions, function(option) {
              return _c(
                "div",
                {
                  key: option.value,
                  staticClass: "collection-sorting__mobile-option",
                  class: _vm.isActvieSortMethod(option.value),
                  on: {
                    click: function($event) {
                      return _vm.mobileSortSelect(option.value)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "body-md" }, [
                    _vm._v(_vm._s(option.label))
                  ])
                ]
              )
            }),
            0
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }